import React, { useState, useEffect, useRef } from "react";
import { v4 as uuidv4 } from "uuid";

export function RenderDisplayTooltip(values) {
  const detailRef = useRef();
  const [isOverflow, setIsOverflow] = useState(true);

  const keyTooltip = uuidv4();

  useEffect(() => {
    setIsOverflow(
      detailRef.current.clientHeight < detailRef.current.scrollHeight
    );
  }, []);

  let numberLines = "--small-size";

  if (values.numberOfLines === 2) {
    numberLines = "--medium-size";
  }

  if (values.numberOfLines === 3) {
    numberLines = "--max-size";
  }

  return (
    <div
      className={`c-table-records-column${numberLines}`}
      data-for={keyTooltip}
      data-tip={values.value}
      style={{
        maxWidth: values.width,
        width: values.width,
      }}
    >
      <label ref={detailRef}>{values.value}</label>
      {isOverflow && (
        <div>
          {/* <Tooltip id={keyTooltip} place="bottom" effect="solid" /> */}
        </div>
      )}
    </div>
  );
}
